if (!customElements.get('size-chart-dialog')) {
  class SizeChartDialog extends HTMLElement {
    constructor() {
      super();
      this.dialog = this.querySelector('[data-size-chart-dialog]');
      this.openButton = this.querySelector('[data-size-chart-open]');
      this.closeButton = this.querySelector('[data-size-chart-close]');
      this.unitButtons = Array.from(this.querySelectorAll('[data-size-chart-unit]'));
      this.unitTables = Array.from(this.querySelectorAll('[data-size-chart-table]'));
      this.previouslyFocused = null;

      this.open = this.open.bind(this);
      this.close = this.close.bind(this);
      this.handleDialogClick = this.handleDialogClick.bind(this);
      this.handleClose = this.handleClose.bind(this);
      this.handleUnitClick = this.handleUnitClick.bind(this);
    }

    connectedCallback() {
      if (!this.dialog || !this.openButton || !this.closeButton) return;

      this.openButton.addEventListener('click', this.open);
      this.closeButton.addEventListener('click', this.close);
      this.dialog.addEventListener('click', this.handleDialogClick);
      this.dialog.addEventListener('close', this.handleClose);
      this.dialog.addEventListener('cancel', this.handleClose);
      this.unitButtons.forEach((button) => button.addEventListener('click', this.handleUnitClick));
    }

    disconnectedCallback() {
      if (!this.dialog || !this.openButton || !this.closeButton) return;

      this.openButton.removeEventListener('click', this.open);
      this.closeButton.removeEventListener('click', this.close);
      this.dialog.removeEventListener('click', this.handleDialogClick);
      this.dialog.removeEventListener('close', this.handleClose);
      this.dialog.removeEventListener('cancel', this.handleClose);
      this.unitButtons.forEach((button) => button.removeEventListener('click', this.handleUnitClick));
    }

    open() {
      this.previouslyFocused = document.activeElement;
      this.dialog.showModal();
      document.body.classList.add('size-chart-open');
      this.closeButton.focus();
    }

    close() {
      this.dialog.close();
    }

    handleDialogClick(event) {
      if (event.target === this.dialog) this.close();
    }

    handleUnitClick(event) {
      const unit = event.currentTarget.dataset.sizeChartUnit;

      this.unitButtons.forEach((button) => {
        const isActive = button.dataset.sizeChartUnit === unit;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });

      this.unitTables.forEach((table) => {
        table.classList.toggle('is-active', table.dataset.sizeChartTable === unit);
      });
    }

    handleClose() {
      document.body.classList.remove('size-chart-open');

      if (this.previouslyFocused && document.contains(this.previouslyFocused)) {
        this.previouslyFocused.focus();
      }
    }
  }

  customElements.define('size-chart-dialog', SizeChartDialog);
}
